// firebase.js
import { initializeApp } from "firebase/app";
import {
  getAuth,
  GoogleAuthProvider,
  RecaptchaVerifier,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  sendPasswordResetEmail,
  signInWithPopup,
  OAuthProvider,
  PhoneAuthProvider,
  getIdToken,
  signOut,
  signInWithPhoneNumber,
  AuthErrorCodes,
  linkWithCredential,
  getAdditionalUserInfo
} from "firebase/auth";
import { analytics } from "../helper/helper";

// const firebaseConfig = {
//   apiKey: "AIzaSyB2NGB6mjFPg78i3uhV3yLN96JkM8j-Y1g",
//   authDomain: "getbitwebappstage.firebaseapp.com",
//   projectId: "getbitwebappstage",
//   storageBucket: "getbitwebappstage.appspot.com",
//   messagingSenderId: "267468914493",
//   appId: "1:267468914493:web:d8a17b69b3009b79d54f54",
//   measurementId: "G-0FK8MH9EV6",
// };

const firebaseConfig = {
  apiKey: "AIzaSyBJyH9WAXQyhu0OoKTpH1aMdTr76b1Y7a0",
  authDomain: "getbit-web-app-c4d11.firebaseapp.com",
  projectId: "getbit-web-app-c4d11",
  storageBucket: "getbit-web-app-c4d11.appspot.com",
  messagingSenderId: "802080839401",
  appId: "1:802080839401:web:19f770a034c21fb0a48278",
  measurementId: "G-CZQP2M1JB0",
};

export const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();
googleProvider.getCustomParameters({
  prompt: "select_account", // Force account selection
});
const appleProvider = new OAuthProvider("apple.com");
appleProvider.addScope("email");
appleProvider.setCustomParameters({
  // Prompt the user to re-authenticate if they've already signed in with Apple.
  prompt: "login",
});

export const firebaseErrorHandler = (code) => {
  let errorMessage = "";
  let errorCode = code;
  if (!code.includes("auth/")) {
    errorCode = "auth/" + code;
  }
  switch (errorCode) {
    case "auth/invalid-email":
      errorMessage = "The email address is not valid.";
      break;
    case "auth/user-not-found":
      errorMessage = "No user found with this email address.";
      break;
    case "auth/wrong-password":
      errorMessage = "Incorrect password.";
      break;
    case "auth/email-already-in-use":
      errorMessage = "This email is already registered.";
      break;
    case "auth/weak-password":
      errorMessage = "The password is too weak. It should be at least 6 characters long.";
      break;
    case "auth/invalid-phone-number":
      errorMessage = "The phone number is not valid.";
      break;
    case "auth/missing-phone-number":
      errorMessage = "The phone number is missing.";
      break;
    case "auth/quota-exceeded":
      errorMessage = "SMS quota exceeded. Try again later.";
      break;
    case "auth/user-disabled":
      errorMessage =
        "The user corresponding to the given phone number has been disabled.";
      break;
    case "auth/operation-not-allowed":
      errorMessage = "Phone number sign-in is not enabled.";
      break;
    case "auth/too-many-requests":
      errorMessage = "Too many requests. Please try again later.";
      break;
    case "auth/app-not-authorized":
      errorMessage =
        "This app is not authorized to use Firebase Authentication.";
      break;
    case "auth/captcha-check-failed":
      errorMessage = "The reCAPTCHA verification failed. Try again.";
      break;
    case "auth/network-request-failed":
      errorMessage = "Network error. Please try again.";
      break;
    case "auth/invalid-verification-code":
      errorMessage = "The verification code is not valid.";
      break;
    case "auth/missing-verification-code":
      errorMessage = "The verification code is missing.";
      break;
    case "auth/code-expired":
      errorMessage =
        "The verification code has expired. Please request a new code.";
      break;
    case "auth/credential-already-in-use":
      errorMessage =
        "This credential is already associated with a different user account.";
      break;
    case "auth/invalid-credential":
      errorMessage =
        "The supplied auth credential is malformed or has expired.";
      break;
    case "auth/popup-closed-by-user":
      errorMessage = "The popup was closed by the user.";
      break;
    case "auth/error-code:-39":
      errorMessage = "Please try again after some time";
      break;
    case "auth/session-expired":
    case "session-expired":
      errorMessage = "Session expired, Please log in again.";
      break;
    case "auth/password-does-not-meet-requirements":
      errorMessage = `The password does not meet the requirements. \n It should be at least 8 characters long. \n It should contain at least one uppercase letter and one lowercase letter. \n It must contain a special character`;
      break;
    case "auth/requires-recent-login":
      errorMessage = "This operation requires recent authentication. Please log in again.";
      break;
    case "auth/invalid-action-code":
      errorMessage = "The action code is invalid. This can happen if the code is malformed, expired, or has already been used.";
      break;
    case "auth/expired-action-code":
      errorMessage = "The action code has expired. Please request a new one.";
      break;
    case "auth/invalid-email-verified":
      errorMessage = "The email verification code is invalid.";
      break;
    case "auth/account-exists-with-different-credential":
      errorMessage = "An account already exists with the same email address but different sign-in credentials.";
      break;
    case "auth/cancelled-popup-request":
      errorMessage = "The popup sign-in was cancelled by the user.";
      break;
    case "auth/popup-blocked":
      errorMessage = "The popup sign-in was blocked by the browser. Please enable popups and try again.";
      break;
    case "auth/unauthorized-domain":
      errorMessage = "This domain is not authorized for OAuth operations.";
      break;
    case "auth/invalid-continue-uri":
      errorMessage = "The continue URL provided in the request is invalid.";
      break;
    case "auth/missing-continue-uri":
      errorMessage = "A continue URL must be provided in the request.";
      break;
    case "auth/missing-ios-bundle-id":
      errorMessage = "An iOS Bundle ID must be provided if an App Store ID is provided.";
      break;
    case "auth/invalid-oauth-provider":
      errorMessage = "The specified OAuth provider is invalid.";
      break;
    case "auth/invalid-oauth-client-id":
      errorMessage = "The OAuth client ID provided is either invalid or does not match the specified API key.";
      break;
    case "auth/unsupported-persistence-type":
      errorMessage = "The current environment does not support the specified persistence type.";
      break;
    case "auth/popup-blocked":
      errorMessage = "The popup sign-in was blocked by the browser. Please enable popups and try again.";
      break;
    case "auth/user-cancelled":
      errorMessage = "The user canceled the sign-in flow.";
      break;
    case "auth/popup-closed-by-user":
      errorMessage = "The popup sign-in was closed by the user.";
      break;
    case "auth/invalid-app-credential":
      errorMessage = "The app credential is invalid. Please try again.";
      break;
    default:
      errorMessage = "An unknown error occurred. Please try again.";
  }
  return errorMessage;
};

export const signInWithEmail = async (email, password) => {
  try {
    const userCredential = await signInWithEmailAndPassword(auth, email, password);
    return userCredential.user;
  } catch (error) {
    throw {
      code: error.code,
      message: firebaseErrorHandler(typeof error.code === 'string' ? error.code : error.message),
    };
  }
};

export const signUpWithEmail = async (email, password) => {
  try {
    const userCredential = await createUserWithEmailAndPassword(auth, email, password);
    return userCredential.user;
  } catch (error) {
    throw {
      code: error.code,
      message: firebaseErrorHandler(typeof error.code === 'string' ? error.code : error.message),
    };
  }
};

export const resetPassword = async (email) => {
  try {
    await sendPasswordResetEmail(auth, email);
  } catch (error) {
    throw {
      code: error.code,
      message: firebaseErrorHandler(typeof error.code === 'string' ? error.code : error.message),
    };
  }
};

export {
  auth,
  getAuth,
  googleProvider,
  RecaptchaVerifier,
  GoogleAuthProvider,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  sendPasswordResetEmail,
  appleProvider,
  signInWithPopup,
  signInWithPhoneNumber,
  AuthErrorCodes,
  signOut,
  linkWithCredential,
  PhoneAuthProvider,
  getAdditionalUserInfo,
  getIdToken,
};
